<template>
    <v-card>
        <breadcrumb :items="breadcrumbs"></breadcrumb>
        <v-container fluid>
            <v-container>
                <v-row class="d-flex">
                    <v-col cols="3">
                        <div class="text-h5 black--text font-weight-bold">Farm Location</div>
                            <gmap-autocomplete :value="address" @place_changed="setPlace" >
                                <!-- <template v-slot:input="slotProps">
                                <input type="text"
                                    ref="input"
                                    v-on:attrs="slotProps.attrs"
                                    class="place-input"/>
                                </template> -->
                            </gmap-autocomplete>
                        <div class="mt-4 subtitle-1 black--text font-weight-bold">Address </div>

                        <div class="text-h5 black--text font-weight-bold">Geographic Location</div>

                        <div class="mt-4 subtitle-1 black--text font-weight-bold">Latitude  </div>
                        <v-text-field
                            v-model="latitude"
                            outlined
                            dense
                            readonly
                        ></v-text-field>

                        <div class=" subtitle-1 black--text font-weight-bold">Longitude</div>
                        <v-text-field
                            v-model="longitude"
                            outlined
                            dense
                            readonly
                        ></v-text-field>


                        <v-btn @click="closeModal" disabled block color="primary" depressed>WALK AND MEASURE</v-btn>
                        <v-btn @click="startGeoFenceTool" :disabled="startGeoFence" block color="primary" class="mt-5" depressed>USE GEOFENCE TOOL</v-btn>
                        <!-- <v-btn @click="$router.push({name: 'GeofenceSub'})" block color="primary" class="mt-5" depressed>Subsection</v-btn> -->
                        <!-- <v-btn @click="updateLocationData" block color="primary" class="mt-5" depressed>Save</v-btn> -->
                    </v-col>
                    <v-col cols="9">
                        <div class="google-map" style="width:100%;height:520px" id="map" ref="googleMap"></div>
                        <div class="d-flex justify-center mt-n12">
                            <v-btn v-if="startGeoFence" @click="saveGeoFence" width="200" color="primary" class="" depressed>Done</v-btn>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
    </v-card>
</template>

<script>
import { Loader } from '@googlemaps/js-api-loader';
import FarmService from "@/_services/farmService";
import loadingMixin from "@/mixins/LoadingMixin";

export default {
    async mounted() {
        // this.farm = await FarmService.getfarm(this.$route.params.farmid);
        const {data} = await FarmService.getPrimaryFarm();
        this.farm = data;
        this.address = this.farm.address;
        if(this.farm.coordinates.length > 0){
            var codes = this.farm.coordinates.map(function(elm) {
                return { lat: parseFloat(elm['lat']), lng: parseFloat(elm['log'])};
            });
            console.log('cds',codes)
            this.parentPolygonCoords = codes;
        }
        if(this.farm.lat && this.farm.log){
                this.latitude  = this.farm.lat;
                this.longitude = this.farm.log;
                this.mapOptions.center.lat = this.latitude;
                this.mapOptions.center.lng = this.longitude;
        }else{
            const success = (position) => {
                this.latitude  = position.coords.latitude;
                this.longitude = position.coords.longitude;
                this.mapOptions.center.lat = this.latitude;
                this.mapOptions.center.lng = this.longitude;
                this.map.setCenter(this.mapOptions.center)
            };
            const error = (err) => {
                console.log(err)
            };
    
            // This will open permission popup
            await navigator.geolocation.getCurrentPosition(success, error);
        }
        

        try {
            const loader = await new Loader({
                apiKey: "AIzaSyBxEppGyQ3YatmT9C8RJjXAh9HsVtpKLh4",
                libraries: ["places", "map", "geometry"]
            }).load()
            .then((google) => {
                this.google = google;
                this.initializeMap(google);
            })
            .catch(e => {
                console.log('Map', e);
            });
            this.loader = loader;
        
        }catch(e) {
            console.log(e);
        }
    },
    props: {
        showMap: {
            type: Boolean,
            require: true
        }
    },

    data() {
        return {
            address: '',
            farm: null,
            startGeoFence: false,
            parentPolygonCoords: [],
            subPolygonCoords: [],
            loader: null,
            latitude: 0,
            longitude: 0,
            google: null,
            map: null,
            marker: null,
            polygon: null,
            subPolygon: null,
            mapOptions: {
                center: {
                    lat: -34.397,
                    lng: 150.644
                },
                styles: {
                    overflow: 'visible'
                },
                zoom: 9,
                disableDefaultUI: true
            },
            breadcrumbs: [
				{
					text: 'Dashboard',
					disabled: false,
					to: '/',
				},
				{
					text: 'Geofence',
					disabled: true,
				},
			],
        }
    },

    methods: {
        async updateLocationData() {
            const area =  await this.google.maps.geometry.spherical.computeArea(this.polygon.getPath());
            var coodinates = this.parentPolygonCoords.map(function(elm) {
                return { lat: elm['lat'], log: elm['lng']};
            });
            const gdata = {
                id: parseInt(this.farm.id),
                lat: this.latitude,
                log: this.longitude,
                farmGeofence: coodinates,
                area
            }
            this.startLoading()
            const {data} = await this.$http.put('/farm', gdata);
            console.log(data)
            this.stopLoading()
        },
        setPlace(place) {
            const latLng = {lat: place.geometry.location.lat(), lng: place.geometry.location.lng()};
            this.map.setCenter(latLng)
            this.latitude = latLng.lat;
            this.longitude = latLng.lng;
            this.address = place.formatted_address
            // console.log('set place', place)

        },
        async saveGeoFence() {
            this.startGeoFence = false;
            this.parentPolygonCoords = [];
            this.polygon.setEditable(false);
            var updated = [];
            const vertices = this.polygon.getPath();
            for (let i = 0; i < vertices.getLength(); i++) {
                const xy = vertices.getAt(i);
                updated.push({lat: xy.lat() , lng: xy.lng()});
            }

            this.parentPolygonCoords = updated;
            const area =  await this.google.maps.geometry.spherical.computeArea(this.polygon.getPath());
            var coodinates = this.parentPolygonCoords.map(function(elm) {
                return { lat: elm['lat'], log: elm['lng']};
            });
            const gdata = {
                id: parseInt(this.farm.id),
                lat: this.latitude,
                log: this.longitude,
                farmGeofence: coodinates,
                address: this.address,
                area
            }
            this.startLoading()
            const {data} = await this.$http.put('/farm', gdata);
            console.log(data)
            this.stopLoading()
            this.$router.push({name: 'Geofence'})
        },
        
        startGeoFenceTool() {
            this.startGeoFence = true;
            this.map.addListener("click", (mapsMouseEvent) => {
                this.updatePolygon(mapsMouseEvent)
            });
        },
        updatePolygon(mapsMouseEvent) {
            const latLng = mapsMouseEvent.latLng.toJSON();
            this.parentPolygonCoords.push(latLng);
            if(this.isAnyCrossover(this.parentPolygonCoords)){
                this.parentPolygonCoords.pop();
                this.$notify({
					title: "No crossover allowed.",
					type: "error",
				});
            }
            this.createPolygon();
        },
        createPolygon(editable=true) {
            if(this.polygon != null) this.polygon.setMap(null);
            this.polygon = new this.google.maps.Polygon({
                paths: this.parentPolygonCoords,
                strokeColor: "#1F5D51",
                strokeOpacity: 0.8,
                strokeWeight: 4,
                fillColor: "#E5F8F1",
                fillOpacity: 0.7,
                editable: editable,
                dragable: true,
                strokePosition: this.google.maps.StrokePosition.INSIDE,
            });
            this.google.maps.event.addListener(this.polygon.getPath(), 'set_at',   this.markerCoords);
            this.google.maps.event.addListener(this.polygon.getPath(), 'insert_at', this.markerCoords);
            this.google.maps.event.addListener(this.polygon.getPath(), 'remove_at', this.markerCoords);
            this.polygon.setMap(this.map);
        },

        isAnyCrossover(coordinates) {
            // NOTE: this currently returns a crossover coordinate or a null but could just return a true/false
            if (coordinates.length >= 4) { 
                // can only have crossover if polygon length >= 4
                for (let i = 0; i < coordinates.length-2; i++) {
                    for (let j = i+1; j < coordinates.length-1; j++) {
                        if (this.doEdgesIntersect(
                        coordinates[i].lat,   coordinates[i].lng,
                        coordinates[i+1].lat, coordinates[i+1].lng,
                        coordinates[j].lat,   coordinates[j].lng,
                        coordinates[j+1].lat, coordinates[j+1].lng)) {
                            return true;
                        }
                        if (this.doEdgesIntersect( // wrap around line segment
                        coordinates[coordinates.length-1].lat, coordinates[coordinates.length-1].lng,
                        coordinates[0].lat,                    coordinates[0].lng,
                        coordinates[j].lat,                    coordinates[j].lng,
                        coordinates[j+1].lat,                  coordinates[j+1].lng)) {
                            return true;
                        }
                    }
                }
            }
            return false; // no crossover detected
        },

        doEdgesIntersect(a,b,c,d,p,q,r,s) {
            let det, gamma, lambda;
            det = (c - a) * (s - q) - (r - p) * (d - b);
            if (det === 0) {
                return false;
            } else {
                lambda = ((s - q) * (r - a) + (p - r) * (s - b)) / det;
                gamma = ((b - d) * (r - a) + (c - a) * (s - b)) / det;
                return (0 < lambda && lambda < 1) && (0 < gamma && gamma < 1);
            }
        },
        closeModal() {
          this.polygon.setMap(null);
          this.parentPolygonCoords = [];
        },

        markerCoords(e) {
            const vertices = this.polygon.getPath();
            var updated = [];
            for (let i = 0; i < vertices.getLength(); i++) {
                const xy = vertices.getAt(i);
                updated.push({lat: xy.lat() , lng: xy.lng()});
            }
            console.log(e);
            this.parentPolygonCoords = updated;
            this.createPolygon();
        },

        async initializeMap(google) {
            this.google = google;
            const mapContainer = this.$refs.googleMap
            this.map = await new google.maps.Map(mapContainer, this.mapOptions);
            // this.map.addListener("click", (mapsMouseEvent) => {
            //     const latLng = mapsMouseEvent.latLng.toJSON();
            //     console.log(latLng)
            // });
            this.createPolygon(false);
        },

    },
    mixins: [loadingMixin]
}

</script>
<style scoped lang="scss">
    ::v-deep .pac-target-input {
        border: 1px solid #898989;
        border-radius: 3px;
        min-height: 40px;
        width: 100%;
        padding: 0px 12px;
        caret-color: #00bd73;
    }
::v-deep .pac-target-input:focus-visible{
        border:1px solid #00bd73;
        outline: none;
    }
    
    </style>